module.exports = __webpack_public_path__ + "images/statisticthumb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/statisticthumb2.png
// module id = N6pY
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13